initiateBackToTopButtons();
initiateLookbookButtons();
initiateQuickAddButtons();
initiateOnQuickOptionButtons("btn-add-book");
initiateOnQuickOptionButtons("options-1");
initiateRegionButtons();
initiateCloseButtons();
initiateCrossSellSelects();
initiateCompleteTheLookATCButtons();
// initiateLoadPreviousButton();

  const hashParameter = window.location.hash;

  if (hashParameter && hashParameter.includes("productId=")) {
    const productId = hashParameter.split("=")[1];
    const productCard = document.querySelector(`#product-${productId}`);

    if (productCard) productCard.scrollIntoView({ behavior: 'auto' });

    // history.replaceState(null, "", `${ window.location.origin }${ window.location.pathname }${ window.location.search }`);
  }

document.addEventListener("click", e => {
  const containerElement = e.target.closest(".quick-add-container");
  
  if (!containerElement) {
    hideQuickAddContainer();
  }
})

window.addEventListener("scroll", (event) => {
  const modalCloseButton = document.querySelector(".quickAddModalMobile .quick-add-close-btn");

  if (modalCloseButton && window.screen.width < 960) modalCloseButton.click();

  hideQuickAddContainer();
});

window.addEventListener("DOMContentLoaded", () => {

  const userInfo = getCookieByName("GlobalE_Data");
  // const userInfo = {"countryISO":"IT","currencyCode":"EUR","cultureCode":"it"}

  setTimeout(async function() {
    const userData = await getUserRegion(userInfo.countryISO);
    // console.log({userData});
    const userRegion = userData.get('userRegion')?.toLowerCase();
    const userCountry = userData.get('countryCode')?.toLowerCase();

    loadVariantLogic(userRegion, userCountry);
    initiateVariantOptionButtons(userRegion);
    validateLineItemsStockByRegion(userRegion);
  }, 1000)
});

function renderPdp(element) {
  const currentUrl = new URL(window.location.href);
  const currentParams = new URLSearchParams(currentUrl.search);
  currentParams.delete("page");
  currentParams.set("page", element.dataset.page);
  const searchParameters = currentParams.size > 0 ? ("?"+ currentParams.toString()) : "";
  const productHash = `#productId=${ element.dataset.productId }`;
  const urlParameters = `${searchParameters}${productHash}`;
  // console.log({urlParameters});
  // debugger;
  history.replaceState(null, "", `${ window.location.origin }${ window.location.pathname }${urlParameters}`);
}

function validateLineItemsStockByRegion(userRegion) {
  const stockAttribute = `data-${userRegion}-stock`;
  const quickCartItems = document.querySelectorAll("#shopify-section-quick-cart .quick-cart__item");
  const updates = {}

  quickCartItems.forEach( quickCartItem => {
    const quickItemStock = quickCartItem.querySelector(".quantity-input__input")? quickCartItem.querySelector(".quantity-input__input").value : 1;
    const quickItemMaxStock = quickCartItem.getAttribute(stockAttribute);
    const itemKey = quickCartItem.dataset.key;

    if (quickItemStock > quickItemMaxStock) {
      updates[itemKey] = parseInt(quickItemMaxStock);
    }
  });

  // if (Object.keys(updates).length){
  //   fetch("/cart/update.js", {
  //     method: "POST",
  //     headers: {
  //       "Content-Type": "application/json",
  //     },
  //     body: JSON.stringify({
  //       updates,
  //     }),
  //   })
  //   .then(() => {
  //     // window.location.reload();
  //   })
  // }
}

function hideQuickAddContainer() {
  const quickAddContainersOpen = document.querySelectorAll(".quick-add-container.open");
  
  quickAddContainersOpen.forEach( quickAddContainerOpen => {
    quickAddContainerOpen.classList.remove("open");
  })
}

function getEnabledVariantOptionButtons(group) {
  return Array.from(group.querySelectorAll(".variant-option-btn")).filter((button) => {
    return button.getAttribute("aria-disabled") !== "true";
  });
}

function syncVariantOptionGroup(group, activeButton) {
  if (!group || !activeButton) return;

  const buttons = group.querySelectorAll(".variant-option-btn");

  buttons.forEach((button) => {
    const isActive = button === activeButton;

    button.classList.toggle("active", isActive);
    button.setAttribute("aria-checked", isActive ? "true" : "false");
    button.setAttribute("tabindex", isActive ? "0" : "-1");
  });
}

function initializeVariantOptionGroups(root = document) {
  root.querySelectorAll(".product-sizes[role='radiogroup']").forEach((group) => {
    const enabledButtons = getEnabledVariantOptionButtons(group);
    const activeButton = group.querySelector(".variant-option-btn.active[aria-disabled='false']") || enabledButtons[0];

    if (activeButton) {
      syncVariantOptionGroup(group, activeButton);
    }
  });
}

function loadVariantLogic(userRegion, userCountry) {
  const stockAttribute = `data-${userRegion}-stock`;
  const variantSelects = document.querySelectorAll("select[data-variant-type='size']");
  const variantSelectOptions = document.querySelectorAll("select[data-variant-type='size']:not(.cross-sell-select) option:not(.disabled)");
  const crossSellsVariantOptions = document.querySelectorAll("select[data-variant-type='size'].cross-sell-select option:not(.disabled)");
  const variantButtonOptions = document.querySelectorAll(".sizes-container ul .variant-option-btn");
  const crossSellItems = document.querySelectorAll(".cross-sells .cross-sells__items .cross-sells__item");
  // const klarnaElement = document.getElementsByTagName("klarna-placement");

  const select2 = document.getElementById("option2");
  if(select2)select2.addEventListener('onchange',()=>{
    select2.dispatchEvent(new Event('change'));
  });

  crossSellsVariantOptions.forEach( crossSellsVariantOption => {
    const variantStock = crossSellsVariantOption.getAttribute(stockAttribute);
    const available = crossSellsVariantOption.getAttribute("data-available");
    if (variantStock == 0 || available=='false') {
      crossSellsVariantOption.classList.add("sold-out");
      crossSellsVariantOption.setAttribute("disabled", "disabled");
      if (!crossSellsVariantOption.text.includes("sold out")) crossSellsVariantOption.text += " - " + window.theme.strings.products.product.sold_out;
    }
  });

  crossSellItems.forEach( crossSellItem => {
    const crossSellValidOptions = crossSellItem.querySelectorAll(".cross-sell-select option:not(disabled):not(.sold-out)");
    if (crossSellValidOptions.length == 0) {
      const crossSellItemAddToCartButton = crossSellItem.querySelector(".cross-sells__item-add");
      
      if (crossSellItemAddToCartButton) {
        const buttonText = crossSellItemAddToCartButton.querySelector(".cross-sells__text-add");
        crossSellItem.classList.add("d-none");
        crossSellItemAddToCartButton.setAttribute("disabled", "disabled");
        buttonText.innerText = window.theme.strings.products.product.sold_out //"Sold Out";
      }
    }
  });

  variantSelectOptions.forEach( (variantOption, i) => {
    if (variantButtonOptions[i] && variantButtonOptions[i].dataset.avoidCountries) {
      const blockedCountries = variantButtonOptions[i].dataset.avoidCountries;

      if (blockedCountries.includes(userCountry)) {
        variantOption.setAttribute(stockAttribute, 0);
        variantButtonOptions[i].setAttribute(stockAttribute, 0);
        variantSelectOptions[i].setAttribute(stockAttribute, 0);
      }
    }

    const variantStock = variantOption.getAttribute(stockAttribute);
    const available = variantOption.getAttribute("data-available");
    const inventoryPolicy = variantOption.getAttribute("data-inventory-policy");
    console.log(`IP ${inventoryPolicy}`)
    console.log(variantOption)
    if (inventoryPolicy != 'continue' && (variantStock == 0 || available == 'false')) {
      variantOption.classList.add("sold-out");
      variantOption.setAttribute("disabled", "disabled");
      if (variantButtonOptions[i]) {
        variantButtonOptions[i].classList.add(`invalid-btn-1`);
        variantButtonOptions[i].setAttribute("aria-disabled", "true");
        variantButtonOptions[i].setAttribute("tabindex", "-1");
      }
      if (!variantOption.text.includes("sold out")) variantOption.text += ` - ${window.theme.strings.products.product.sold_out}`;
    } else if (variantStock < 5) {
      if (variantButtonOptions[i]) {
        variantButtonOptions[i].setAttribute("aria-disabled", "false");
      }
      if (variantButtonOptions[i] && variantButtonOptions[i].closest(".variant-sizes")) {
        if (!variantButtonOptions[i].querySelector(".few-items-disclaimer")) {
          variantButtonOptions[i].insertAdjacentHTML("beforeend", `<span class="few-items-disclaimer">${window.theme.strings.products.product.few_items_left}</span>`);
        }
      }
    } else if (variantButtonOptions[i]) {
      variantButtonOptions[i].setAttribute("aria-disabled", "false");
    }

  });

  initializeVariantOptionGroups();

  variantSelects.forEach( variantSelect => {
    const firstOptionAvalilable = variantSelect.querySelector("option:not(:disabled):not(.default-option)");
    if (firstOptionAvalilable) {
      // firstOptionAvalilable.selected = true;
    } else {
      const addToCartButton = variantSelect.closest(".quick-product")?.querySelector(".product-form__cart-submit");
      const formButtom = variantSelect.closest(".product-content")?.querySelector(".product-form__cart-submit");
      const formATCButtom = variantSelect.closest(".product-content")?.querySelector(".btn-add-to-cart");
      const productBadgesContainer = variantSelect.closest(".product-item")?.querySelector(".product-badges");

      if (addToCartButton) {
        addToCartButton.setAttribute("disabled", "disabled");
        addToCartButton.querySelector("span[data-add-to-cart-text]").innerHTML = `${window.theme.strings.products.product.sold_out}`;
      }

      if (formButtom) {
        formButtom.setAttribute("disabled", "disabled");
        formButtom.querySelector("span[data-add-to-cart-text]").innerHTML = `${window.theme.strings.products.product.sold_out}`;
      }

      if (formATCButtom) {
        formATCButtom.setAttribute("disabled", "disabled");
        formATCButtom.querySelector("span").innerHTML = `${window.theme.strings.products.product.sold_out}`;
      }

      if (productBadgesContainer) {
        const soldOutBadge = productBadgesContainer.querySelector(".product-badge--sold-out");

        if (!soldOutBadge) {
          const globaleClasses = productBadgesContainer.classList.contains('adidas-product')? "d-none globale-show" : "";
          const soldOutBadgeElement = `<div class="product-badge product-badge--sold-out ${globaleClasses}">${window.theme.strings.products.product.sold_out}</div>`;

          productBadgesContainer.insertAdjacentHTML("beforeend", soldOutBadgeElement);
        }
      }
      // if (klarnaElement.length) klarnaElement[0].remove();
    }
  });
}

function initiateCompleteTheLookATCButtons() {
  document.addEventListener("click", e => {
    const addToCartButton = e.target.closest(".btn-blocked-by-size");

    if (addToCartButton) {
      const completeTheLookItem = addToCartButton.closest(".complete-the-look-item");
      const variantSelect = completeTheLookItem.querySelector(".size-selector");

      if (variantSelect && variantSelect.value == "") {
        const productForm = completeTheLookItem.querySelector("form.product-form");
        e.preventDefault();
        productForm.classList.add("invalid-size");
      }
    }
  });
}

// function initiateLoadMoreButton() {
//   document.addEventListener("click", e => {
//     const loadMoreButton = e.target.closest(".collection__infinite-trigger [data-click-to-load]");
// 
//     if (loadMoreButton) {
//       const currentUrl = new URL(location);
//       const currentPage = loadMoreButton.dataset.page;
//       currentUrl.searchParams.set("page", currentPage);
//       history.pushState({}, "", url);
//       console.log({history});
//     }
//   });
// }

function initiateBackToTopButtons() {
  document.addEventListener("click", e => {
    const backToTopButton = e.target.closest(".btn-back-to-top");

    if (backToTopButton) {
      const supportsNativeSmoothScroll = ("scrollBehavior" in document.documentElement.style);

      if (supportsNativeSmoothScroll) {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      } else {
        window.scrollTo(0, 0);
      }
    }

  });
}

function initiateLookbookButtons() {
  document.addEventListener("click", e => {
    const lookbookButton = e.target.closest(".lb-caption li[data-url]");

    if (lookbookButton) {
      const url = lookbookButton.dataset.url;

      window.location.href = url;
    }
  });
}

function initiateOnQuickOptionButtons(selectorClass) {
  document.addEventListener("click", e => {
    const bookQuickActionButton = e.target.closest(`.quick-add-btn.${selectorClass}`);

    if (bookQuickActionButton) {
      const quickAddContainer = bookQuickActionButton.closest(".quick-add-container");
      const submitButton = quickAddContainer.querySelector(".product-form__cart-submit");

      if (submitButton) {
        submitButton.click();
        closeQuickAddPopups();
      }
    }
  });
}

function initiateVariantOptionButtons(userRegion) {
  document.addEventListener("click", e => {
    const quickAddButton = e.target.closest(".variant-option-btn:not(.invalid-btn)");
    if (quickAddButton) {
      const stockAttribute = `data-${userRegion}-stock`;
      const quickAddContainer = quickAddButton.closest(".quick-add-container")?? quickAddButton.closest(".product__details");
      const sizeSelector = quickAddContainer.querySelector(".size-selector");
      const submitButton = quickAddContainer.querySelector(".product-form__cart-submit");
      const inventoryWrapperContainer = document.querySelector(".inventoryWrapper");
      const variantStock = quickAddButton.getAttribute(stockAttribute);
      const variantLowInventoryThreshold = parseInt(quickAddButton.dataset.lowInventory);
      const available = quickAddButton.getAttribute("data-available");
      if (quickAddButton.closest(".quick-add-container")) {
        if(quickAddButton.classList.contains('invalid-btn-1')){
          return;
        }
        const quickAddMobile = quickAddButton.closest(".quickAddModalMobile");

        if (quickAddMobile) {
          const dataVariantId = quickAddButton.dataset.variantId;
          const productItemContainer = document.querySelector(`.product-item .variant-option-btn[data-variant-id="${dataVariantId}"]`);
          productItemContainer.click();
        } else {
          sizeSelector.value = quickAddButton.dataset.sizeDefault;
          submitButton.click();
          closeQuickAddPopups();
          // changeModalValue(quickAddButton.dataset.sizeDefault, true);
        }
      } else {
        const buttonValue = quickAddButton.querySelector(".desktop")? quickAddButton.querySelector(".desktop").dataset.size : quickAddButton.dataset.sizeDefault;
        const defaultOption = sizeSelector.querySelector("option.disabled");
        const newSelectedOption = sizeSelector.querySelector(`option[value='${buttonValue}']`);
        const optionGroup = quickAddButton.closest(".product-sizes");
        if (defaultOption) defaultOption.removeAttribute("selected");
        if (newSelectedOption) newSelectedOption.setAttribute("selected", "selected");
        setTimeout(()=> {
          sizeSelector.value = buttonValue;
          sizeSelector.dispatchEvent(new Event('change',{bubbles: true}));
          sizeSelector.click();
          syncVariantOptionGroup(optionGroup, quickAddButton);
        }, 100);
      }

      if (variantStock && variantStock != 0 && variantStock <= variantLowInventoryThreshold && available=='true') {
        if (inventoryWrapperContainer) {
          inventoryWrapperContainer.innerHTML = `${window.theme.strings.products.product.few_items_left}`;
          inventoryWrapperContainer.classList.remove("invisible");
        }
      } else {
        if (inventoryWrapperContainer) {
          inventoryWrapperContainer.innerHTML = ".";
          inventoryWrapperContainer.classList.add("invisible");
        }
      }
    }

  });
}

document.addEventListener("keydown", (e) => {
  const optionButton = e.target.closest(".variant-option-btn");

  if (!optionButton) return;

  if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    optionButton.click();
    return;
  }

  if (!["ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"].includes(e.key)) return;

  const optionGroup = optionButton.closest(".product-sizes");
  if (!optionGroup) return;

  const buttons = getEnabledVariantOptionButtons(optionGroup);
  if (!buttons.length) return;

  const currentIndex = buttons.indexOf(optionButton);
  if (currentIndex === -1) return;

  e.preventDefault();

  let nextIndex = currentIndex;

  if (e.key === "ArrowLeft" || e.key === "ArrowUp") {
    nextIndex = currentIndex === 0 ? buttons.length - 1 : currentIndex - 1;
  } else if (e.key === "ArrowRight" || e.key === "ArrowDown") {
    nextIndex = currentIndex === buttons.length - 1 ? 0 : currentIndex + 1;
  } else if (e.key === "Home") {
    nextIndex = 0;
  } else if (e.key === "End") {
    nextIndex = buttons.length - 1;
  }

  const nextButton = buttons[nextIndex];

  if (nextButton) {
    nextButton.focus();
    nextButton.click();
  }
});

function initiateCrossSellSelects() {
  document.addEventListener("change", e => {
    const crossSellSelect = e.target.closest(".cross-sells__item-button .cross-sell-select");

    if (crossSellSelect) {
      const crossSellAddToCartButton = crossSellSelect.closest(".cross-sells__item-button").querySelector(".cross-sells__item-add");
      const selectedOption = crossSellSelect.options[crossSellSelect.selectedIndex];
      // console.log({selectedOption});

      if (crossSellAddToCartButton) crossSellAddToCartButton.dataset.addItemId = selectedOption.dataset.variantId;
    }

  });
}

// function initiateCompleteTheLookSelects() {
//   document.addEventListener("change", e => {
//     const crossSellSelect = e.target.closest(".complete-look .size-selector");
// 
//     if (crossSellSelect) {
//       const crossSellAddToCartButton = crossSellSelect.closest(".quick-product").querySelector(".product-form__cart-submit");
// 
//       if (crossSellAddToCartButton) {
//         crossSellAddToCartButton.classList.remove("btn--tertiary");
//         crossSellAddToCartButton.classList.add("btn--primary");
//         crossSellAddToCartButton.removeAttribute("disabled");
//       }
//     }
// 
//   });
// }


// function changeModalValue(newValue, closePopups = false) {
//   const interval = setInterval(function() {
//     const modalElement = document.querySelector(".quick-view-modal__content");
//     if (modalElement && !modalElement.classList.contains("empty")){
//       clearInterval(interval);
//       const modalSizeSelector = modalElement.querySelector(".size-selector");
//       const modalSubmmitButton = modalElement.querySelector(".product-form__cart-submit");
//       modalSizeSelector.value = newValue;
//       modalSubmmitButton.click();
//       if (closePopups) closeQuickAddPopups();
//     }
//   }, 500);
// }

function initiateQuickAddButtons() {
  document.addEventListener("click", e => {
    const quickAddButton = e.target.closest(".quick-add-btn:not(.btn-add-book)");

    if (quickAddButton) {
      const quickAddModalMobile = document.querySelector(".quickAddModalMobile");
      const quickAddItemImage = e.target.closest(".product-item__media");
      const quickAddContainer = e.target.closest(".quick-add-container");
      const producItemContainer = e.target.closest(".product-item");
      const quickAddModalButton = producItemContainer.querySelector(".show-product-quickview");
      closeQuickAddPopups();
      quickAddItemImage?.classList.add("static");
      quickAddContainer?.classList.add("open");
      // quickAddModalButton.click();
      quickAddModalMobile?.classList.add("open");
      quickAddModalMobile?.appendChild(quickAddContainer.cloneNode(true));

      if (quickAddButton.closest(".nosto-quick-add")) {
        const sourceQuickAddPrice = quickAddContainer?.querySelector(".product-item__price2");
        const modalQuickAddPrice = quickAddModalMobile?.querySelector(".product-item__price2");

        if (sourceQuickAddPrice && modalQuickAddPrice) {
          modalQuickAddPrice.innerHTML = sourceQuickAddPrice.innerHTML;
        }
      }
    }

  });
}

function initiateCloseButtons() {
  document.addEventListener("click", e => {
    const quickAddCloseButton = e.target.closest(".quick-add-close-btn");

    if (quickAddCloseButton) closeQuickAddPopups();
  });
}

function closeQuickAddPopups() {
  const quickAddContainers = document.querySelectorAll(".quick-add-container.open");
  const quickAddItemImages = document.querySelectorAll(".product-item__media.static");
  const closeModalButton = document.querySelector(".modal__close-icon");
  const quickAddModalMobile = document.querySelector(".quickAddModalMobile");

  if (quickAddModalMobile) {
    quickAddModalMobile.innerHTML = "";
    quickAddModalMobile.classList.remove("open");
  }

  if (closeModalButton) closeModalButton.click();

  quickAddContainers.forEach( quickAddContainer => {
    quickAddContainer.classList.remove("open");
  });

  quickAddItemImages.forEach( quickAddItemImage => {
    quickAddItemImage.classList.remove("static");
  });
}

function initiateRegionButtons() {
  document.addEventListener("click", e => {
    const regionButton = e.target.closest(".btn-region");

    if (regionButton) {
      const region = regionButton.dataset.label;
      const sizesContainer = regionButton.closest(".sizes-container");
      const productSizes = (sizesContainer.querySelectorAll(".shoes-sizes li").length > 0)? sizesContainer.querySelectorAll(".shoes-sizes li") : sizesContainer.querySelectorAll(".product-sizes li");
      const regionButtons = sizesContainer.querySelectorAll(".btn-region");

      regionButtons.forEach( regionButton => {
        regionButton.classList.remove("selected");
      });

      regionButton.classList.add("selected");

      productSizes.forEach( productSize => {
        const newLabel = productSize.getAttribute(`data-size-${region}`);
        productSize.innerHTML = newLabel;
      })
    }
  });
}

function initiateLoadPreviousButton() {
  document.addEventListener("click", e => {
    const paginateButton = e.target.closest(".btn-paginate-load-previous");

    if (paginateButton) {
      e.preventDefault();
      const pageUrl = paginateButton.getAttribute("href");
      const currentScrollPosition = window.scrollY;
      // console.log({currentScrollPosition})

      fetch(pageUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(htmlResponse) {
        // console.log({htmlResponse});
        const parser = new DOMParser();
        const elementResponse = parser.parseFromString(htmlResponse, "text/html");
        const productsContainer = document.querySelector(".collection__infinite-container");

        window.scrollTo(0, currentScrollPosition);

        if (productsContainer) {
          const elementsToInject = elementResponse.querySelector(".collection__infinite-container");
          // console.log({elementsToInject});
          productsContainer.insertAdjacentHTML("afterbegin", elementsToInject.innerHTML);

          // load("product");
        }

      })
      .catch(function(err) {  
        console.log('Failed to fetch page: ', err);  
      });
    }
  });
}

function handleAddToCart(e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  const addToCartForm = e.target.closest('.product-form');
  
  if (addToCartForm) {
    const sizeSelector = addToCartForm.querySelector(".size-selector");

    if (!sizeSelector.value) {
      swal({
        position: 'top-end',
        text: "Please select a size first!",
        showConfirmButton: false,
        timer: 6000,
        dangerMode: true
      })
    } else {
      const formData = new FormData(addToCartForm);
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => {
        const quickCartSection = window.Shopify.theme.sections.instances.find(
          (instance) => instance.container?.classList.contains('quick-cart')
        );

        if (quickCartSection) {
          const cartIcons = document.querySelectorAll(".cart-icon span[data-js-cart-count]");
          quickCartSection.refreshQuickCart();
          quickCartSection.openQuickCart();
          if (cartIcons) {
            cartIcons.forEach( cartIcon => {
              cartIcon.innerText = (parseInt(cartIcon.innerText) + 1);
            })
          }
        }

      })
      .catch((error) => {
        if (error && error.message) {
          swal({
            position: 'top-end',
            title: 'Error',
            text: `${error.message}`,
            showConfirmButton: false,
            timer: 6000,
            dangerMode: true
          })
        }
      });
    }
  }
}
